// Chakra imports
import { Portal, Box, useDisclosure } from '@chakra-ui/react'
import Footer from 'components/footer/FooterAdmin.js'
// Layout components
import Navbar from 'components/navbar/NavbarAdmin.js'
import Sidebar from 'components/sidebar/Sidebar.js'
import { SidebarContext } from 'contexts/SidebarContext'
import React, { useState } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import routes from 'routes.js'
import { useAuthStore } from 'store/auth.store'

import sidebarRoutes from 'components/sidebar/adminRoutes'

export default function Dashboard (props) {
  const { ...rest } = props
  const { user, isLoggedIn, token } = useAuthStore()
  const role = user?.role ? String(user.role).trim().toLowerCase() : ''
  const location = useLocation()
  const [fixed] = useState(false)
  const [toggleSidebar, setToggleSidebar] = useState(false)
  const { onOpen } = useDisclosure()

  // Strict Authentication Check
  if (!isLoggedIn || !token || !user) {
    return <Navigate to='/auth/sign-in' replace />
  }

  // Strictly block Gate Keepers from entering Admin layout
  if (role === 'gate_keeper') {
    return <Navigate to='/gatekeeper/check-in' replace />
  }

  // Strictly require Admin role for Admin layout
  if (role !== 'admin') {
    return <Navigate to='/auth/sign-in' replace />
  }

  // Function to get the current route name based on the location.pathname
  const getActiveRoute = (routesList) => {
    const currentPath = location.pathname
    let activeRoute = 'User'

    for (let i = 0; i < routesList.length; i++) {
      if (routesList[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routesList[i].items)
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute
        }
      } else if (routesList[i].category) {
        let categoryActiveRoute = getActiveRoute(routesList[i].items)
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute
        }
      } else {
        const routePath = routesList[i].layout + routesList[i].path
        if (currentPath === routePath) {
          return routesList[i].name
        }
      }
    }
    return activeRoute
  }

  const getActiveNavbar = (routesList) => {
    const currentPath = location.pathname
    let activeNavbar = false
    for (let i = 0; i < routesList.length; i++) {
      if (routesList[i].collapse) {
        let collapseActiveNavbar = getActiveNavbar(routesList[i].items)
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar
        }
      } else if (routesList[i].category) {
        let categoryActiveNavbar = getActiveNavbar(routesList[i].items)
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar
        }
      } else {
        const routePath = routesList[i].layout + routesList[i].path
        if (currentPath === routePath) {
          return routesList[i].secondary
        }
      }
    }
    return activeNavbar
  }

  const getActiveNavbarText = (routesList) => {
    const currentPath = location.pathname
    let activeNavbar = false
    for (let i = 0; i < routesList.length; i++) {
      if (routesList[i].collapse) {
        let collapseActiveNavbar = getActiveNavbarText(routesList[i].items)
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar
        }
      } else if (routesList[i].category) {
        let categoryActiveNavbar = getActiveNavbarText(routesList[i].items)
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar
        }
      } else {
        const routePath = routesList[i].layout + routesList[i].path
        if (currentPath === routePath) {
          return routesList[i].messageNavbar
        }
      }
    }
    return activeNavbar
  }

  const getRoute = () => {
    return location.pathname !== '/admin/full-screen-maps'
  }

  const getRoutes = (routesList) => {
    return routesList.map((route, key) => {
      if (route.layout === '/admin') {
        return (
          <Route path={`${route.path}`} element={route.component} key={key} />
        )
      }
      if (route.collapse) {
        return getRoutes(route.items)
      } else {
        return null
      }
    })
  }

  document.documentElement.dir = 'ltr'

  return (
    <Box>
      <Box>
        <SidebarContext.Provider
          value={{
            toggleSidebar,
            setToggleSidebar,
          }}
        >
          <Sidebar routes={sidebarRoutes} display='none' {...rest} />
          <Box
            float='right'
            minHeight='100vh'
            height='100%'
            overflow='auto'
            position='relative'
            maxHeight='100%'
            w={{ base: '100%', xl: 'calc( 100% - 290px )' }}
            maxWidth={{ base: '100%', xl: 'calc( 100% - 290px )' }}
            transition='all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)'
            transitionDuration='.2s, .2s, .35s'
            transitionProperty='top, bottom, width'
            transitionTimingFunction='linear, linear, ease'
          >
            <Portal>
              <Box>
                <Navbar
                  onOpen={onOpen}
                  logoText={'Horizon UI Dashboard PRO'}
                  brandText={getActiveRoute(routes)}
                  secondary={getActiveNavbar(routes)}
                  message={getActiveNavbarText(routes)}
                  fixed={fixed}
                  {...rest}
                />
              </Box>
            </Portal>

            {getRoute() ? (
              <Box
                mx='auto'
                p={{ base: '20px', md: '30px' }}
                pe='20px'
                minH='100vh'
                pt='50px'
              >
                <Routes>
                  {getRoutes(routes)}
                  <Route
                    path='/'
                    element={<Navigate to='/admin/users' replace />}
                  />
                </Routes>
              </Box>
            ) : null}
            <Box>
              <Footer />
            </Box>
          </Box>
        </SidebarContext.Provider>
      </Box>
    </Box>
  )
}
